

<app-table-standard-layout [dataSource$]="products$" [title]="'Products'"  [rowActionButtons]="rowActionButtons"  [topbarActionButton]="topbarActionButton" [columnSettings]="columnSettings" ></app-table-standard-layout>
<!-- 
<div class="card-container">
  <div class="band">
    <mat-form-field class="example-full-width">
      <input matInput placeholder="Search product..." [formControl]="filter">
    </mat-form-field>
  </div>
</div>
<app-card-view-layout  
[data]="filteredStates$"   (onDelete)="onDeleteProduct($event)"
(onUpdate)="onUpdateProduct($event)" > -->

  

  <!-- <button card class="card" (click)="addMore()">Load more</button>
  <button list class="list" (click)="addMore()">Load more</button>
</app-card-view-layout> -->